import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3148, { U3148ROLES } from "./U3148";
import U3148RedirectToCurrentOrg from "./components/U3148RedirectToCurrentOrg";
import U3148OrganizationForm from "./components/U3148OrganizationForm";
import U3148RoleForm from "./components/U3148RoleForm";
import U3148AffiliationForm from "./components/U3148AffiliationForm";

// Typage pour les routes
interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

// Définition des routes pour l'unité logique U3148
const U3148Routes: RouteObject[] = [
  {
    path: "U3148",
    element: <U2000RequireRole allowedRoles={[U3148ROLES.READ]} requireOrganizationId />,
    children: [
      {
        path: "",
        element: <U3148 />,
        children: [
          { index: true, element: <U3148RedirectToCurrentOrg /> },
          {
            path: ":id/affiliation/:affiliationId",
            element: <U3148AffiliationForm />,
          },
          {
            path: ":id/role/:roleId",
            element: <U3148RoleForm />,
          },
          { path: ":id", element: <U3148OrganizationForm /> },
        ],
      },
    ],
  },
];

export default U3148Routes;
